// extracted by mini-css-extract-plugin
module.exports = {"rotate":"styles_rotate__2_bbG"};